import React, { useState } from 'react';
import PropTypes from 'prop-types';

import paymentScheduleIcon from 'core/assets/svg/ic-payment-schedule-24px.svg';
import { PaymentScheduleModal } from 'quote-revisit/components/payment-schedule-modal';
// The slots module itself, not its index: the index loads every fill, this one included.
import { PolicyCardSlot } from '../slots/slots';
import useStyles from './payment-schedule-link.styles';

export const slot = PolicyCardSlot.PaymentScheduleLink;

/**
 * The policy card's "Payment schedule" link (#36360), which opens the payment schedule modal. The card
 * only renders this slot for policies paid in more than one payment, so escrow and one-time policies
 * have no link.
 */
const PaymentScheduleLink = ({ policy }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={classes.link}
        aria-label={`${policy.title} payment schedule`}
        onClick={() => setOpen(true)}
      >
        <img src={paymentScheduleIcon} alt="" className={classes.icon} />
        Payment schedule
      </button>
      {open && <PaymentScheduleModal open onClose={() => setOpen(false)} policy={policy} />}
    </>
  );
};

PaymentScheduleLink.propTypes = {
  policy: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired
};

export default PaymentScheduleLink;
